import { memo } from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FullPaddingWrapper } from "../../Components/FullPaddingWrapper/FullPaddingWrapper";
import { SentimentDissatisfied } from "@mui/icons-material";
import MessageUsPanel from "../../Components/MessageForm/MessageUsPanel";
import APP_ROUTES from "../../Configurations/APP_ROUTES";

/**
 * 404. Was a dead end with one button; now anyone who lands here can tell us
 * what they were after (Asher, October 2026), and the message reaches him with
 * the broken address attached.
 */
const NotFoundPage = memo(() => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl">
      <FullPaddingWrapper>
        <Box
          textAlign="center"
          py={{ xs: 5, md: 8 }}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <SentimentDissatisfied sx={{ fontSize: 72, color: "text.secondary", mb: 1.5 }} />
          <Typography variant="h2" fontWeight={700} gutterBottom>
            404
          </Typography>
          <Typography variant="h5" gutterBottom>
            We couldn't find that page
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 460 }}>
            The link may be old, or the page may have moved.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ mb: { xs: 5, md: 6 }, width: { xs: "100%", sm: "auto" } }}>
            <Button variant="contained" size="large" onClick={() => navigate("/")} sx={{ textTransform: "none" }}>
              Search for a home
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate(String(APP_ROUTES.CONTACT.pathname))}
              sx={{ textTransform: "none" }}
            >
              Contact us
            </Button>
          </Stack>

          <MessageUsPanel
            align="center"
            topic="broken-page"
            title="Tell us what you were looking for"
            intro="We'll point you to it, or fix the link. Your message goes straight to the SimplerHome team."
            messagePlaceholder="e.g. I clicked a link in an email about my home and ended up here."
          />
        </Box>
      </FullPaddingWrapper>
    </Container>
  );
});

export default NotFoundPage;
